
import { useState } from 'react';
import { useDarkMode } from "../../../../context/ThemeContext";

export default function TrucksSection() {
  const { isDarkMode } = useDarkMode();
  
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [showAddModal, setShowAddModal] = useState(false);

  const themeClasses = {
    bg: isDarkMode ? 'bg-dark-surface' : 'bg-white',
    border: isDarkMode ? 'border-dark-border' : 'border-gray-200',
    text: isDarkMode ? 'text-white' : 'text-gray-900',
    textSecondary: isDarkMode ? 'text-gray-400' : 'text-gray-600',
    cardBg: isDarkMode ? 'bg-dark-card' : 'bg-white',
    cardBorder: isDarkMode ? 'border-dark-border' : 'border-gray-200',
    buttonHover: isDarkMode ? 'hover:bg-dark-card' : 'hover:bg-gray-100',
    buttonText: isDarkMode ? 'text-gray-400' : 'text-gray-600',
    buttonTextHover: isDarkMode ? 'hover:text-white' : 'hover:text-gray-900'
  };

  const trucks = [
    {
      id: 'TRK-001',
      model: 'Freightliner Cascadia',
      year: 2022,
      plates: 'DM-58-SUB780A',
      vin: '1FUJGHDV8NLAA1234',
      status: 'active',
      driver: 'Carlos Mendoza',
      mileage: 125000,
      fuelLevel: 85,
      lastMaintenance: '15 días',
      nextMaintenance: '2,500 km',
      location: 'Ciudad de México',
      image: 'https://readdy.ai/api/search-image?query=Modern%20white%20Freightliner%20Cascadia%20truck%2C%20professional%20commercial%20vehicle%20photography%2C%20clean%20background%2C%20side%20view%2C%20high%20quality%20truck%20image&width=300&height=200&seq=truck1&orientation=landscape'
    },
    {
      id: 'TRK-002',
      model: 'Volvo VNL 860',
      year: 2021,
      plates: 'ECO-4-LIGHT+',
      vin: '4V4NC9EH8MN123456',
      status: 'active',
      driver: 'Ana García',
      mileage: 98000,
      fuelLevel: 62,
      lastMaintenance: '8 días',
      nextMaintenance: '1,200 km',
      location: 'Guadalajara',
      image: 'https://readdy.ai/api/search-image?query=Modern%20blue%20Volvo%20VNL%20truck%2C%20professional%20commercial%20vehicle%20photography%2C%20clean%20background%2C%20side%20view%2C%20high%20quality%20truck%20image&width=300&height=200&seq=truck2&orientation=landscape'
    },
    {
      id: 'TRK-003',
      model: 'Kenworth T680',
      year: 2020,
      plates: 'KW-T680-MX',
      vin: '1XKYDP9X8LJ123456',
      status: 'maintenance',
      driver: 'Sin asignar',
      mileage: 156000,
      fuelLevel: 25,
      lastMaintenance: 'En curso',
      nextMaintenance: 'En mantenimiento',
      location: 'Taller Central',
      image: 'https://readdy.ai/api/search-image?query=Modern%20red%20Kenworth%20T680%20truck%2C%20professional%20commercial%20vehicle%20photography%2C%20clean%20background%2C%20side%20view%2C%20high%20quality%20truck%20image&width=300&height=200&seq=truck3&orientation=landscape'
    },
    {
      id: 'TRK-004',
      model: 'Peterbilt 579',
      year: 2023,
      plates: 'PB-579-NEW',
      vin: '1XP5DB9X8PD123456',
      status: 'inactive',
      driver: 'Sin asignar',
      mileage: 45000,
      fuelLevel: 90,
      lastMaintenance: '5 días',
      nextMaintenance: '3,800 km',
      location: 'Base Central',
      image: 'https://readdy.ai/api/search-image?query=Modern%20black%20Peterbilt%20579%20truck%2C%20professional%20commercial%20vehicle%20photography%2C%20clean%20background%2C%20side%20view%2C%20high%20quality%20truck%20image&width=300&height=200&seq=truck4&orientation=landscape'
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active': return 'text-primary-500 bg-primary-500/10';
      case 'inactive': return 'text-red-500 bg-red-500/10';
      case 'maintenance': return 'text-amber-500 bg-amber-500/10';
      case 'out_of_service': return 'text-gray-500 bg-gray-500/10';
      default: return 'text-gray-500 bg-gray-500/10';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'active': return 'Activo';
      case 'inactive': return 'Inactivo';
      case 'maintenance': return 'Mantenimiento';
      case 'out_of_service': return 'Fuera de servicio';
      default: return 'Desconocido';
    }
  };

  const getFuelLevelColor = (level: number) => {
    if (level > 50) return 'bg-primary-500';
    if (level > 25) return 'bg-amber-500';
    return 'bg-red-500';
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className={`${themeClasses.bg} border-b ${themeClasses.border} p-6`}>
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1 className={`text-2xl font-bold ${themeClasses.text}`}>Gestión de Camiones</h1>
            <p className={`${themeClasses.textSecondary} mt-1`}>Administra toda la flota de camiones</p>
          </div>
          <button 
            onClick={() => setShowAddModal(true)}
            className="bg-primary-500 hover:bg-primary-400 text-white px-4 py-2 rounded-lg font-medium flex items-center space-x-2 transition-colors whitespace-nowrap"
          >
            <i className="ri-add-line"></i>
            <span>Nuevo Camión</span>
          </button>
        </div>

        <div className="flex items-center space-x-4">
          <select
            value={selectedFilter}
            onChange={(e) => setSelectedFilter(e.target.value)}
            className={`px-3 py-2 ${isDarkMode ? 'bg-dark-card' : 'bg-gray-50'} border ${themeClasses.cardBorder} rounded-lg ${themeClasses.text} text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 pr-8`}
          >
            <option value="all">Todos los camiones</option>
            <option value="active">Activos</option>
            <option value="inactive">Inactivos</option>
            <option value="maintenance">En mantenimiento</option>
            <option value="out_of_service">Fuera de servicio</option>
          </select>

          <div className="relative">
            <i className={`ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 ${themeClasses.textSecondary} text-sm`}></i>
            <input
              type="text"
              placeholder="Buscar por placas o modelo..."
              className={`pl-10 pr-3 py-2 ${isDarkMode ? 'bg-dark-card' : 'bg-gray-50'} border ${themeClasses.cardBorder} rounded-lg ${themeClasses.text} placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm w-64`}
            />
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {trucks.map((truck) => (
            <div key={truck.id} className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl overflow-hidden hover:shadow-lg transition-all`}>
              {/* Truck Image */}
              <div className="relative h-48">
                <img 
                  src={truck.image} 
                  alt={truck.model}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 right-4">
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(truck.status)}`}>
                    {getStatusText(truck.status)}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 bg-black/70 text-white px-3 py-1 rounded-lg">
                  <span className="text-sm font-medium">{truck.plates}</span>
                </div>
              </div>

              <div className="p-5">
                {/* Truck Header */}
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className={`font-semibold ${themeClasses.text} text-lg`}>{truck.model}</h3>
                    <p className={`text-sm ${themeClasses.textSecondary}`}>{truck.year} • {truck.id}</p>
                  </div>
                  <div className="text-right">
                    <p className={`text-sm ${themeClasses.textSecondary}`}>Conductor</p>
                    <p className={`text-sm ${themeClasses.text} font-medium`}>{truck.driver}</p>
                  </div>
                </div>

                {/* Truck Details */}
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <p className={`text-xs ${themeClasses.textSecondary} mb-1`}>VIN</p>
                    <p className={`text-sm ${themeClasses.text} font-mono`}>{truck.vin}</p>
                  </div>
                  <div>
                    <p className={`text-xs ${themeClasses.textSecondary} mb-1`}>Ubicación</p>
                    <p className={`text-sm ${themeClasses.text}`}>{truck.location}</p>
                  </div>
                  <div>
                    <p className={`text-xs ${themeClasses.textSecondary} mb-1`}>Kilometraje</p>
                    <p className={`text-sm ${themeClasses.text} font-semibold`}>{truck.mileage.toLocaleString()} km</p>
                  </div>
                  <div>
                    <p className={`text-xs ${themeClasses.textSecondary} mb-1`}>Último mantenimiento</p>
                    <p className={`text-sm ${themeClasses.text}`}>{truck.lastMaintenance}</p>
                  </div>
                </div>

                {/* Fuel Level */}
                <div className="mb-4">
                  <div className="flex items-center justify-between mb-2">
                    <span className={`text-sm ${themeClasses.textSecondary}`}>Nivel de combustible</span>
                    <span className={`text-sm ${themeClasses.text} font-semibold`}>{truck.fuelLevel}%</span>
                  </div>
                  <div className={`w-full ${isDarkMode ? 'bg-gray-600' : 'bg-gray-200'} rounded-full h-2`}>
                    <div 
                      className={`h-2 rounded-full transition-all ${getFuelLevelColor(truck.fuelLevel)}`}
                      style={{ width: `${truck.fuelLevel}%` }}
                    ></div>
                  </div>
                </div>

                {/* Maintenance Info */}
                <div className={`p-3 ${isDarkMode ? 'bg-gray-800' : 'bg-gray-50'} rounded-lg mb-4`}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                      <i className={`ri-tools-line text-sm ${themeClasses.textSecondary}`}></i>
                      <span className={`text-sm ${themeClasses.textSecondary}`}>Próximo mantenimiento</span>
                    </div>
                    <span className={`text-sm ${themeClasses.text} font-medium`}>{truck.nextMaintenance}</span>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex space-x-2">
                  <button className={`flex-1 py-2 px-3 ${themeClasses.buttonHover} border ${themeClasses.cardBorder} rounded-lg ${themeClasses.buttonText} ${themeClasses.buttonTextHover} text-sm font-medium transition-colors`}>
                    Editar
                  </button>
                  <button className="py-2 px-3 bg-primary-500 hover:bg-primary-400 text-white rounded-lg text-sm font-medium transition-colors">
                    Ver Detalles
                  </button>
                  <button className={`py-2 px-3 ${themeClasses.buttonHover} border ${themeClasses.cardBorder} rounded-lg ${themeClasses.buttonText} ${themeClasses.buttonTextHover} text-sm transition-colors`}>
                    <i className="ri-map-pin-line"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Add Truck Modal */}
      {showAddModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className={`${themeClasses.cardBg} rounded-xl p-6 w-full max-w-lg`}>
            <div className="flex items-center justify-between mb-4">
              <h3 className={`text-lg font-semibold ${themeClasses.text}`}>Nuevo Camión</h3>
              <button 
                onClick={() => setShowAddModal(false)}
                className={`${themeClasses.buttonText} ${themeClasses.buttonTextHover} p-1`}
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            
            <form className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className={`block text-sm font-medium ${themeClasses.text} mb-1`}>Modelo</label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2 ${isDarkMode ? 'bg-dark-card' : 'bg-gray-50'} border ${themeClasses.cardBorder} rounded-lg ${themeClasses.text} focus:outline-none focus:ring-2 focus:ring-primary-500`}
                    placeholder="Freightliner Cascadia"
                  />
                </div>
                
                <div>
                  <label className={`block text-sm font-medium ${themeClasses.text} mb-1`}>Año</label>
                  <input
                    type="number"
                    className={`w-full px-3 py-2 ${isDarkMode ? 'bg-dark-card' : 'bg-gray-50'} border ${themeClasses.cardBorder} rounded-lg ${themeClasses.text} focus:outline-none focus:ring-2 focus:ring-primary-500`}
                    placeholder="2023"
                  />
                </div>
              </div>
              
              <div>
                <label className={`block text-sm font-medium ${themeClasses.text} mb-1`}>Placas</label>
                <input
                  type="text"
                  className={`w-full px-3 py-2 ${isDarkMode ? 'bg-dark-card' : 'bg-gray-50'} border ${themeClasses.cardBorder} rounded-lg ${themeClasses.text} focus:outline-none focus:ring-2 focus:ring-primary-500`}
                  placeholder="ABC-123-DEF"
                />
              </div>
              
              <div>
                <label className={`block text-sm font-medium ${themeClasses.text} mb-1`}>VIN</label>
                <input
                  type="text"
                  className={`w-full px-3 py-2 ${isDarkMode ? 'bg-dark-card' : 'bg-gray-50'} border ${themeClasses.cardBorder} rounded-lg ${themeClasses.text} focus:outline-none focus:ring-2 focus:ring-primary-500`}
                  placeholder="1FUJGHDV8NLAA1234"
                />
              </div>
              
              <div>
                <label className={`block text-sm font-medium ${themeClasses.text} mb-1`}>Kilometraje inicial</label>
                <input
                  type="number"
                  className={`w-full px-3 py-2 ${isDarkMode ? 'bg-dark-card' : 'bg-gray-50'} border ${themeClasses.cardBorder} rounded-lg ${themeClasses.text} focus:outline-none focus:ring-2 focus:ring-primary-500`}
                  placeholder="0"
                />
              </div>
              
              <div className="flex space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowAddModal(false)}
                  className={`flex-1 py-2 px-4 ${themeClasses.buttonHover} border ${themeClasses.cardBorder} rounded-lg ${themeClasses.buttonText} font-medium transition-colors`}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="flex-1 py-2 px-4 bg-primary-500 hover:bg-primary-400 text-white rounded-lg font-medium transition-colors"
                >
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
